import { Attr, BelongsTo, Model } from "spraypaint";

import type { FeatureId } from "shared/helpers/features";
import { ApplicationRecord } from "shared/services/spraypaint";

import type OrganisationContract from "./OrganisationContract";

@Model()
class ContractsFeature extends ApplicationRecord {
  static jsonapiType = "contracts_features";

  @Attr({ persist: false }) accessLevel: any;

  @Attr({ persist: false }) billable: boolean;

  @BelongsTo() contract: OrganisationContract;

  @Attr() contractId: number;

  @Attr() cost: number;

  @Attr({ persist: false }) description: string;

  @Attr() enabled: boolean;

  @Attr() feature: FeatureId;

  @Attr({ persist: false }) flaggable: boolean;

  @Attr({ persist: false }) label: string;

  @Attr({ persist: false }) locked: boolean;

  @Attr() monthlyCredits: number;

  @Attr({ persist: false }) name: string;

  @Attr({ persist: false }) parentFeatureId: number;

  @Attr({ persist: false }) position: number;

  @Attr({ persist: false }) tag: string;

  @Attr() unlimited: boolean;
}

export default ContractsFeature;
